import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WEB_REFS } from '../../store/dataCapture/payloadUtils/getDocumentPayload';

const jsonReplacer = (key,value) => {
    if (key === "content_type") return undefined;
    else if (key === "reason") return undefined;
    else return value;
};

const documentVersionJSON = JSON.stringify(WEB_REFS, jsonReplacer);

const DocumentVersionPage = () => (
      <StandardBody>
        {documentVersionJSON}
      </StandardBody>
);

export default DocumentVersionPage;

